/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ElementOrigin,
  ProjectSurvey2DInfo,
  ProjectSurveyLinkageShift,
  ProjectSurveyShiftCalcParams,
  ProjectSurveyShiftResult,
  Survey2DInfo,
  SurveyProfileInfo,
} from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ProjectSurvey2DClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags ProjectSurvey2d
   * @summary Получить 2D-съёмки по проекту.
   * @request GET:/Seismic/project/{projectId}/survey2d
   * @secure
   */
  projectSurvey2DGetSurveys2DByProjectId = (projectId: string, params: RequestParams = {}) =>
    this.http.request<Survey2DInfo[], any>({
      path: `/Seismic/project/${projectId}/survey2d`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectSurvey2d
   * @summary Добавить 2D-съёмку к проекту, включая все дочерние профили.
   * @request POST:/Seismic/project/{projectId}/survey2d
   * @secure
   */
  projectSurvey2DAddSurvey2DToProject = (
    projectId: string,
    query: {
      /**
       * Идентификатор съёмки.
       * @format uuid
       */
      survey2dId: string
      /** Происхождение съёмки. */
      elementOrigin?: ElementOrigin
    },
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/Seismic/project/${projectId}/survey2d`,
      method: 'POST',
      query: query,
      secure: true,
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectSurvey2d
   * @summary Получить проектные 2D-съёмки и проектные профили.
   * @request GET:/Seismic/project/{projectId}/survey2d/ProjectSurvey2dList
   * @secure
   */
  projectSurvey2DGetProjectSurveys2DList = (projectId: string, params: RequestParams = {}) =>
    this.http.request<ProjectSurvey2DInfo[], any>({
      path: `/Seismic/project/${projectId}/survey2d/ProjectSurvey2dList`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectSurvey2d
   * @summary Получить список значений увязки для проектных 2D-съёмок и связанным проектным профилям.
   * @request POST:/Seismic/project/{projectId}/survey2d/GetProjectSurveyLinkageShiftList
   * @secure
   */
  projectSurvey2DGetProjectSurveyLinkageShiftList = (
    projectId: string,
    data: string[],
    params: RequestParams = {},
  ) =>
    this.http.request<ProjectSurveyLinkageShift[], any>({
      path: `/Seismic/project/${projectId}/survey2d/GetProjectSurveyLinkageShiftList`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectSurvey2d
   * @summary Обновить в БД значения увязок - twt-сдвиги для проектной 2D-съёмки и связанным проектным профилям.
   * @request PUT:/Seismic/project/{projectId}/survey2d/UpdateProjectSurveyLinkageShift
   * @secure
   */
  projectSurvey2DUpdateProjectSurveyLinkageShift = (
    projectId: string,
    data: ProjectSurveyLinkageShift,
    params: RequestParams = {},
  ) =>
    this.http.request<boolean, any>({
      path: `/Seismic/project/${projectId}/survey2d/UpdateProjectSurveyLinkageShift`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectSurvey2d
   * @summary Рассчитать значения увязки - twt-сдвиги для проектной 2D-съёмки и связанным проектным профилям.
   * @request POST:/Seismic/project/{projectId}/survey2d/CalcProjectSurveyLinkageShift
   * @secure
   */
  projectSurvey2DCalcProjectSurveyLinkageShift = (
    projectId: string,
    data: ProjectSurveyShiftCalcParams,
    params: RequestParams = {},
  ) =>
    this.http.request<ProjectSurveyShiftResult[], any>({
      path: `/Seismic/project/${projectId}/survey2d/CalcProjectSurveyLinkageShift`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectSurvey2d
   * @summary Получить одинаковые профили 2D-съёмок по проекту.
   * @request GET:/Seismic/project/{projectId}/survey2d/sameSurveys2dProfiles
   * @secure
   */
  projectSurvey2DGetSameProjectSurveys2DProfiles = (
    projectId: string,
    query: {
      /**
       * Идентификатор профиля 2D-съёмки.
       * @format uuid
       */
      profileId: string
    },
    params: RequestParams = {},
  ) =>
    this.http.request<SurveyProfileInfo[], any>({
      path: `/Seismic/project/${projectId}/survey2d/sameSurveys2dProfiles`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectSurvey2d
   * @summary Получить 2D-съёмку по проекту и горизонту.
   * @request GET:/Seismic/project/{projectId}/survey2d/horizon/{horizonId}
   * @secure
   */
  projectSurvey2DGetSurvey2DByProjectAndHorizonId = (
    projectId: string,
    horizonId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<Survey2DInfo[], any>({
      path: `/Seismic/project/${projectId}/survey2d/horizon/${horizonId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectSurvey2d
   * @summary Дополнить 2D-съёмку в проекте новыми профилями.
   * @request PUT:/Seismic/project/{projectId}/survey2d/survey/{surveyId}
   * @secure
   */
  projectSurvey2DUpdateSurvey2DProfileListInProject = (
    projectId: string,
    surveyId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/Seismic/project/${projectId}/survey2d/survey/${surveyId}`,
      method: 'PUT',
      secure: true,
      ...params,
    })
}
